import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// // 🔒 Disable console output in production to prevent data leaks and reduce noise
// // Only keep console.error for critical errors in production
if (!process.env.REACT_APP_DEBUG) {
  console.log = () => { };
  console.debug = () => { };
  console.info = () => { };
  console.warn = () => { };  // Also disable warnings in production
}
console.log = () => { };
console.warn = () => { };
console.debug = () => { };
console.info = () => { };
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
